// extracted by mini-css-extract-plugin
module.exports = {"button":"LessMore_button__Qovlq"};